import PageGL from './gl/main';
import Opening from './gl/opening/main';
import Zuhan from './gl/zuhan/main';
import Introduction from './introduction/main';
import Slide from "./slide";


export default class Main{
    
    constructor() {
        this._init();
    }
    
    _init(){
        this.op = new Opening();
        this.zuhan = new Zuhan();
        
        window.MyGL = this.mygl = new PageGL();
        this.mygl.load(this._glSetup.bind(this));

        const introduction = new Introduction();
        const slide = new Slide();
    }

    _glSetup(){
        this.op.setup();
        this.zuhan.setup();
    }
}
